import { FundFamilySetupTabProps } from "features/fund-family/setup/FundFamilySetupTabProps";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs } from "shared/components/layout/PageTabs";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const FundFamilySetupNoticesPage: React.FC = () => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();

  const { fundFamilyId } = useRequiredStringParams();

  const onCancel = () => {
    navigate(rootRoute({}).fundFamilies({}).$);
  };

  const tabContext: FundFamilySetupTabProps = { fundFamilyId, onCancel };

  return (
    <PageContent>
      <PageHeader title={t("common:notices")} />
      <PageBody>
        <PageTabs context={tabContext} />
      </PageBody>
    </PageContent>
  );
};
